export default __webpack_public_path__ + "static/media/img_major01_2.d2a7f6e9.jpg";